/**
 * @file
 * Navigation, mobile menu and dismissible banner behaviors for layerone.
 *
 * Requires global.js to be loaded first (Drupal.layerone.getScreenWidth).
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.layeroneNavigation = {
    attach: function (context, settings) {

      // Show top tip off / navigation banner messages based on session state.
      $('.close-me', context).each(function() {
        var session = $(this).data('session');
        if (session !== 'undefined') {
          var closeItem = '.' + $(this).data('close');

          const sessionData = sessionStorage.getItem(session);

          if ((sessionData !== 'undefined' || sessionData === null) && sessionData !== 'no-display') {
            $(this).parents(closeItem).show();
          }
        }

      });

      // Close the closeItem when close button clicked and set action in session.
      $('.close-me', context).click(function() {
        var closeItem = '.' + $(this).data('close');
        var session = $(this).data('session');
        $(this).parents(closeItem).slideUp();
        if (closeItem === '.navigation-banner-item') {
          sessionStorage.setItem(session, 'no-display');
        }
        let selector = '#search-filters-container';
        if ($(selector).length > 0) {
          $(selector).removeClass('pb-2rem');
        }
      });

      // The mobile menu's breakpoint (theme settings > Navigation; 768 unless
      // changed) and, with data-nav-fit, the switch to the mobile menu at
      // any width when the links don't fit beside the logo and the header's
      // components (.nav-fit-mobile, abstracts/_nav_breakpoint.scss).
      const header = document.getElementById('header');
      const navBreakpoint = (header && parseInt(header.dataset.navBreakpoint, 10)) || 768;
      const navBp = (header && header.dataset.navBp) || 'md';

      function isDesktopNav() {
        return Drupal.layerone.getScreenWidth() >= navBreakpoint && !(header && header.classList.contains('nav-fit-mobile'));
      }

      // The mobile menu wider than the breakpoint: without the Bootstrap
      // classes that expand the menu and hide the Menu button from there.
      function setNavFitMobile(on) {
        let nav = document.getElementById('navbar-main');
        let toggle = document.getElementById('mobile-nav-toggle');
        header.classList.toggle('nav-fit-mobile', on);
        if (nav) {
          nav.classList.toggle('navbar-expand-' + navBp, !on);
          nav.parentElement.classList.toggle('flex-' + navBp + '-row', !on);
        }
        if (toggle) {
          toggle.parentElement.classList.toggle('d-' + navBp + '-none', !on);
        }
      }

      // Whether the row of links fits: not cut off, on one line, and clear
      // of the logo and the header's components (e.g. a Get a quote
      // button) by a small gap.
      function navLinksFit() {
        let menu = document.querySelector('#block-layerone-mainnavigation .navbar-nav');
        let items = menu ? Array.from(menu.children).filter(function (item) {
          return item.classList.contains('nav-item') && item.offsetParent !== null;
        }) : [];
        if (!items.length) {
          return true;
        }
        let gap = 8;
        let first = items[0].getBoundingClientRect();
        let last = items[items.length - 1].getBoundingClientRect();
        let logo = document.querySelector('.header-row > .main-logo-container');
        let components = document.querySelector('.header-row > .header-row-components');
        if (menu.scrollWidth > menu.clientWidth + 1 || last.top >= first.bottom) {
          return false;
        }
        if (logo && logo.offsetWidth && first.left < logo.getBoundingClientRect().right + gap) {
          return false;
        }
        if (components && components.offsetWidth && last.right > components.getBoundingClientRect().left - gap) {
          return false;
        }
        return true;
      }

      // Tries the row of links (no paint happens in between) and keeps the
      // mobile menu if they don't fit. Left alone while the mobile menu is
      // open, when the logo and components are hidden.
      function checkNavFit() {
        if (!header || !header.hasAttribute('data-nav-fit')) {
          return;
        }
        let forced = header.classList.contains('nav-fit-mobile');
        if (Drupal.layerone.getScreenWidth() < navBreakpoint) {
          if (forced) {
            setNavFitMobile(false);
          }
          return;
        }
        if (forced && $('#layerone-header-navigation').hasClass('is-open')) {
          return;
        }
        let $menu = $('#block-layerone-mainnavigation');
        let wasCollapsed = $menu.hasClass('collapsed');
        setNavFitMobile(false);
        $menu.addClass('collapsed');
        let fits = navLinksFit();
        $menu.toggleClass('collapsed', wasCollapsed);
        if (!fits) {
          setNavFitMobile(true);
        }
      }

      $('.clean-links .nav-link').each(function() {
        $(this).wrapInner('<span class="layerone-text-wrapper"></span>');
      });

      function moveSidebarSecond() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let $sidebar = $(document.getElementById('layerone-sidebar-second-content'));

        if ($('#sidebar_second', context).length > 0) {

          if (screenWidth < 768) {
            $sidebar.appendTo('#layerone-sidebar-second-insert');
          } else {
            if ($('#sidebar_second', context).find('layerone-sidebar-second-content').length === 0) {
              $sidebar.appendTo('#sidebar_second');
            }
          }
        }
      }

      function moveNewsFilters() {
        let $form = $(document.getElementById('views-exposed-form-latest-news-block-2'));
        let $viewHeader = false;
        if ($form.length > 0) {
          $viewHeader = $('#block-layerone-views-block-latest-news-block-2 .view-header', context);
        }
        if ($('.node--type-landing-page #sidebar_second').length > 0) {
          $form.appendTo('#search-filters-container');
          if ($viewHeader.length > 0) {
            $viewHeader.appendTo('#search-filters-container');
          }
        }

        let $searchForm = $(document.getElementById('views-exposed-form-search-page-1'));
        if ($searchForm.length > 0 && $('.page-view-search').length > 0) {
          $searchForm.appendTo('#search-filters-container');
        }
      }

      // Site header rebuild, Phase 6 follow-up (docs/site_header_rebuild_
      // plan.md §5/§7): the custom background/height/is-open reset that
      // makes the mobile panel actually look closed - Bootstrap's own
      // data-bs-toggle handles #collapsing-nav's own show/hide (and
      // keeps #mobile-nav-toggle/#close-nav-toggle's .collapsed class in
      // sync, since they share one data-bs-target), but never touches
      // any of this. Shared so #close-nav-toggle (below) can trigger the
      // exact same close, not just Bootstrap's half of it - it was never
      // wired to this at all before, only ever running Bootstrap's own
      // toggle, which is why the panel's own background/height used to
      // stay put after clicking it once #mobile-nav-toggle (the only
      // trigger that DID call this) was hidden while open.
      function closeMobileNav() {
        $('#close-nav-toggle').css({position: '', top: '', left: '', right: '', width: '', height: ''});
        $('#mobile-nav-toggle').addClass('collapsed').hide();
        $('#navbar-main').hide();
        $('#close-nav-toggle').hide();
        let navigation = $('#layerone-header-navigation');
        $('.offcanvas-open').hide();
        // is-open is a plain state class, deliberately separate from
        // the mobile panel's own background colour - that's admin-
        // configurable now (data-background-open, page-header.html.
        // twig), so CSS that needs to know "is the mobile menu open"
        // (e.g. #mobile-nav-toggle's visibility once open, _navigation.
        // scss) can't key off whichever colour happens to be in use.
        // Collapsed no longer sets a background colour of its own at
        // all (site header rebuild follow-up) - #layerone-header-
        // navigation sits inside .header-row/#header in this state,
        // never as a full-screen panel, so whatever's already behind it
        // (the header's own field_header_background_colour in Banner
        // mode, or the page showing through in Floating mode) already
        // covers it; data-background-collapsed/field_mobile_menu_bg_
        // collapsed are left in place, just unused now, rather than
        // removed unasked.
        navigation.css('background-color', '').removeClass('w-100').removeClass('is-open').css('height', 'unset');
        $('#banner').show();
        // Site header rebuild, Phase 5 (docs/site_header_rebuild_plan.md
        // §5): #layerone-header-navigation moved from a sibling of
        // #header to a child of it, so hiding #header itself here would
        // hide the nav along with it - only the logo/header-region parts
        // outside the nav toggle now.
        $('.main-logo-container, .header-row-components').show();
        $('#mobile-nav-toggle').show();
        $('#navbar-main').show();
      }

      // The open menu's close button exactly where the Menu button was (same
      // size and place), so opening and closing the menu happen on the same
      // spot. On the next frame, once Bootstrap has shown the menu; then
      // corrected by where it actually landed, as a header ancestor can
      // offset position: fixed.
      // Where the Menu button was when clicked: measured before any click
      // handler runs (capture phase) - Bootstrap's collapse toggle has
      // already changed the header by the time this file's handler runs.
      let menuButtonBox = {width: 0};
      if (!window.layeroneMenuButtonBoxBound) {
        window.layeroneMenuButtonBoxBound = true;
        window.addEventListener('click', function (event) {
          let button = event.target.closest && event.target.closest('#mobile-nav-toggle');
          if (button) {
            window.layeroneMenuButtonBox = button.getBoundingClientRect();
          }
        }, true);
      }

      function alignCloseButton() {
        let toggleBox = window.layeroneMenuButtonBox || menuButtonBox;
        let close = document.getElementById('close-nav-toggle');
        if (!close || !toggleBox.width) {
          return;
        }
        window.requestAnimationFrame(function () {
          close.style.position = 'fixed';
          close.style.right = 'auto';
          close.style.width = toggleBox.width + 'px';
          close.style.height = toggleBox.height + 'px';
          close.style.top = toggleBox.top + 'px';
          close.style.left = toggleBox.left + 'px';
          let landed = close.getBoundingClientRect();
          if (landed.width) {
            close.style.top = (2 * toggleBox.top - landed.top) + 'px';
            close.style.left = (2 * toggleBox.left - landed.left) + 'px';
          }
        });
      }

      $('#mobile-nav-toggle').click(function() {
        if ($(this).hasClass('collapsed')) {
          // Clicked while open (mobile menu showing)
          closeMobileNav();
        } else {
          // Clicked while collapsed (main screen showing).
          $('#navbar-main').show();
          // closeMobileNav() (above) hides #close-nav-toggle on the way
          // out - nothing was showing it back on the way in, so it only
          // ever worked the first time (before any close had run) and
          // silently stayed hidden every open after that.
          $('#close-nav-toggle').show();
          let navigation = $('#layerone-header-navigation');
          let mobileBackground = navigation.data('background-open');
          $('.offcanvas-open').show();
          navigation.css('background-color', mobileBackground).addClass('w-100').addClass('is-open').css('height', '100vh');
          $('.region-navigation-banner').hide();
          $('#banner').hide();
          $('.main-logo-container, .header-row-components').hide();
          $(this).removeClass('collapsed');
          alignCloseButton();
        }

      });

      // #close-nav-toggle shares #mobile-nav-toggle's data-bs-target, so
      // Bootstrap's own collapse toggle already runs on click (hiding
      // #collapsing-nav, syncing .collapsed on both buttons) - this is
      // only the custom half Bootstrap doesn't know about.
      $('#close-nav-toggle').click(function() {
        closeMobileNav();
      });

      // Site header rebuild, Phase 7 (docs/site_header_rebuild_plan.md
      // §3/§7): .show-nav-dropdown/.show-back-dropdown are now real
      // <button>s (menu--main.html.twig) - Enter/Space and Tab already
      // work natively, nothing extra needed here for that. The one
      // thing that does need this JS is aria-expanded, which has no
      // native/CSS equivalent - kept in sync with the same show/hide
      // calls these handlers already make.
      //
      // A top-level trigger carries aria-haspopup="true" only when the
      // mega-menu is switched on (menu--main.html.twig) - matches a
      // genuinely different desktop interaction (a flyout panel that
      // appears *alongside* the rest of the top bar) from the plain
      // drill-down every other trigger still does (replaces the visible
      // list with the child list) - mobile always gets the drill-down
      // regardless, a hover-driven flyout has no touchscreen equivalent.
      // isDesktopNav() is checked fresh on every interaction,
      // not cached, so a resize across the breakpoint mid-session (a
      // rotated tablet, a resized desktop window) is never stale.
      function isMegaMenuTrigger($button) {
        return isDesktopNav() && $button.attr('aria-haspopup') === 'true';
      }

      function openMegaMenuPanel($button) {
        $button.attr('aria-expanded', 'true');
        $button.parents('.nav-item').first().find('> .mega-menu-panel').addClass('is-open');
      }

      function closeMegaMenuPanel($button) {
        $button.attr('aria-expanded', 'false');
        $button.parents('.nav-item').first().find('> .mega-menu-panel').removeClass('is-open');
      }

      // Closes whichever mega-menu panel is currently open, if any -
      // shared by Escape, outside-click and focus-out below, all of
      // which need "close the open one" without already knowing which
      // trigger opened it.
      function closeAnyOpenMegaMenuPanel() {
        let $openTrigger = $('.show-nav-dropdown[aria-haspopup="true"][aria-expanded="true"]');
        if ($openTrigger.length) {
          closeMegaMenuPanel($openTrigger);
          return $openTrigger;
        }
        return null;
      }

      $('.show-nav-dropdown').click(function() {
        if (isMegaMenuTrigger($(this))) {
          openMegaMenuPanel($(this));
          return;
        }
        $(this).parents('.navbar-nav').find('.nav-item').hide();
        $(this).parents('.nav-item').show();
        let navItem = $(this).parents('.nav-item');
        navItem.find('.link-container').addClass('d-none').removeClass('d-flex');
        navItem.find('.back-container').addClass('d-flex').removeClass('d-none');
        navItem.find('.dropdown-menu').show();
        $(this).attr('aria-expanded', 'true');
      });

      $('.show-back-dropdown').click(function() {
        let $trigger = $(this).parents('.nav-item').find('.show-nav-dropdown');
        if (isMegaMenuTrigger($trigger)) {
          // The "Back" control isn't shown at all in the mega-menu
          // panel presentation (_navigation.scss) - this only fires if
          // it somehow still receives a click (e.g. a mouse click on
          // the now-decorative chevron icon, which keeps this class
          // for exactly that reason) - close the same way Escape/
          // outside-click would.
          closeMegaMenuPanel($trigger);
          return;
        }
        $(this).parents('.navbar-nav').find('.nav-item').show();
        let navItem = $(this).parents('.nav-item');
        navItem.find('.link-container').addClass('d-flex').removeClass('d-none');
        navItem.find('.back-container').addClass('d-none').removeClass('d-flex');
        navItem.find('.dropdown-menu').hide();
        navItem.find('.show-nav-dropdown').attr('aria-expanded', 'false');
      });

      // Hover open/close - the one interaction a plain click/keyboard
      // trigger can't provide. Only bound to top-level .nav-item.dropdown
      // (mega-menu candidates); isMegaMenuTrigger's own checks (desktop
      // width + aria-haspopup) still gate whether hovering actually does
      // anything, so this is a no-op everywhere else (mobile, or a
      // top-level item when the mega-menu is off).
      let megaMenuHoverCloseTimer = null;
      $('.navbar-nav > .nav-item.dropdown').on('mouseenter', function() {
        let $trigger = $(this).find('> .link-container .show-nav-dropdown');
        if (!isMegaMenuTrigger($trigger)) {
          return;
        }
        clearTimeout(megaMenuHoverCloseTimer);
        // A different top-level item may already have its own panel
        // open (moving the mouse directly from one trigger to the next,
        // without a gap) - close it first so two panels are never open
        // at once.
        closeAnyOpenMegaMenuPanel();
        openMegaMenuPanel($trigger);
      }).on('mouseleave', function() {
        let $trigger = $(this).find('> .link-container .show-nav-dropdown');
        if (!isMegaMenuTrigger($trigger)) {
          return;
        }
        // A short delay, not an instant close - moving the mouse from
        // the trigger down into the panel itself briefly leaves the
        // .nav-item's own hover area; closing immediately would make
        // the panel unreachable by mouse at all.
        megaMenuHoverCloseTimer = setTimeout(function() {
          closeMegaMenuPanel($trigger);
        }, 200);
      });

      // Escape closes the open panel and returns focus to its own
      // trigger - the WAI-ARIA Authoring Practices' own disclosure
      // pattern requirement, and the one piece of keyboard support a
      // hover-oriented flyout doesn't get for free.
      $(document).on('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          let $trigger = closeAnyOpenMegaMenuPanel();
          if ($trigger) {
            $trigger.trigger('focus');
          }
        }
      });

      // Closes on outside click/focus-out, per the same requirement -
      // anything inside the open panel or its own trigger is exempt,
      // everything else (another part of the page, another top-level
      // nav item) closes it.
      $(document).on('click focusin', function(event) {
        let $openTrigger = $('.show-nav-dropdown[aria-haspopup="true"][aria-expanded="true"]');
        if (!$openTrigger.length) {
          return;
        }
        let $navItem = $openTrigger.parents('.nav-item').first();
        if ($navItem.is(event.target) || $navItem.has(event.target).length) {
          return;
        }
        closeMegaMenuPanel($openTrigger);
      });

      function mobileMenu() {
        checkNavFit();
        let mobileMenuDisappear = navBreakpoint;
        let screenWidth = Drupal.layerone.getScreenWidth();
        if (isDesktopNav()) {
          // Site header rebuild follow-up: this forced height/padding
          // only ever made sense in Banner mode - Floating mode's whole
          // point is that #header has no box of its own and the page's
          // first component (often #banner) shows through behind the
          // logo/nav row; forcing a real, visible 258px height onto it
          // fights that directly (reported: a "white banner" appearing
          // right where Floating mode expects nothing, resizing through
          // exactly 768). Never applied in Floating mode at all now,
          // not just cleared afterward - and still cleared back to auto
          // whenever the width isn't exactly 768, in Banner mode too,
          // since nothing previously cleared it once a resize continued
          // past that one pixel either way.
          if (screenWidth === mobileMenuDisappear && !$('#header').hasClass('site-header--floating')) {
            $('#banner').css('height', '258px').css('padding-bottom', '40px');
            $('#banner > .container').css('height', '218px');
          }
          else {
            $('#banner').css('height', '').css('padding-bottom', '');
            $('#banner > .container').css('height', '');
          }
          $('#block-layerone-mainnavigation').addClass('collapsed');
          let navigation = $('#layerone-header-navigation');
          $('.offcanvas-open').hide();
          // Site header rebuild follow-up: no background colour of its
          // own once collapsed - see closeMobileNav()'s own note above,
          // same reasoning applies here (this is the resize/load-time
          // equivalent of that same collapse).
          navigation.css('background-color', '').removeClass('w-100').removeClass('is-open').css('height', 'unset');
          $('.region-navigation-banner').show();
          $('#banner').show();
          // Site header rebuild, Phase 5 (docs/site_header_rebuild_plan.md
          // §5): #layerone-header-navigation is now a child of #header,
          // not a sibling - see the matching note in the click handler
          // above.
          $('.main-logo-container, .header-row-components').show();
          $('#mobile-nav-toggle').addClass('collapsed');
        }
        else {
          // Same clearing as the desktop branch's own "not exactly
          // 768" case above - the forced height/padding-bottom must
          // not survive a resize all the way down into mobile either.
          $('#banner').css('height', '').css('padding-bottom', '');
          $('#banner > .container').css('height', '');
          $('#block-layerone-mainnavigation').removeClass('collapsed');
          if ($('#collapsing-nav').hasClass('show')) {
            let navigation = $('#layerone-header-navigation');
            let mobileBackground = navigation.data('background-open');
            $('.offcanvas-open').show();
            navigation.css('background-color', mobileBackground).addClass('w-100').addClass('is-open').css('height', '100vh');
            $('.region-navigation-banner').hide();
            $('#banner').hide();
            $('.main-logo-container, .header-row-components').hide();
            $('#mobile-nav-toggle').removeClass('collapsed');
          }
        }

      }

      moveSidebarSecond();
      moveNewsFilters();
      mobileMenu();

      window.addEventListener('resize', function(){
        moveSidebarSecond();
        // moveNewsFilters();
        mobileMenu();
      },true);

      // The links' widths change once the web fonts arrive.
      if (header && header.hasAttribute('data-nav-fit') && !header.dataset.navFitBound) {
        header.dataset.navFitBound = '1';
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(mobileMenu);
        }
        window.addEventListener('load', mobileMenu);
      }

    }
  };

  // A floating header sits over the top of the page, so a page that starts
  // with its title (no banner behind the header) had the title under the
  // navigation. --page-title-clear on the title: how far the navigation row
  // reaches below the title's top, which components/_page_title.scss adds to
  // the "Page title space above". 0 when the header isn't floating or the
  // title is further down the page.
  Drupal.behaviors.layeronePageTitleClear = {
    attach: function (context) {
      once('layerone-page-title-clear', '#header.site-header--floating', context).forEach(function (header) {
        var row = header.querySelector('.header-row');
        var title = document.querySelector('h1.page-title-heading');
        if (!row || !title) {
          return;
        }
        function clear() {
          title.style.removeProperty('--page-title-clear');
          var headerBottom = (parseFloat(getComputedStyle(header).top) || 0) + row.offsetHeight;
          var titleTop = title.getBoundingClientRect().top + window.scrollY;
          var overlap = Math.ceil(headerBottom - titleTop);
          if (overlap > 0) {
            title.style.setProperty('--page-title-clear', overlap + 'px');
          }
        }
        clear();
        window.addEventListener('resize', clear);
        window.addEventListener('load', clear);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(clear);
        }
      });
    }
  };

  // Site header rebuild, Phase 6 (docs/site_header_rebuild_plan.md §5/§7).
  // This behavior's main job is still just detecting when
  // .header-sticky-sentinel has scrolled out of view and toggling
  // #header.is-stuck accordingly - _header.scss decides everything about
  // what .is-stuck looks like or does (desktop-only, via its own media
  // query), this never checks the viewport width itself.
  //
  // One thing genuinely can't be a static CSS rule though: once stuck,
  // <header>'s own box collapses to 0 (_header.scss), and whatever
  // immediately follows it - not always the same element; page.html.twig
  // can put #banner, page.highlighted or #main-wrapper right after it
  // depending on the page - needs to pick up an equivalent amount of
  // padding-top, so the collapse reads as one smooth motion rather than
  // an instant snap. The two heights involved (the header's own natural
  // size, and the shrunk row's) depend on admin config and actual
  // rendered content, so they have to be measured here, not guessed at
  // in CSS.
  Drupal.behaviors.layeroneStickyHeader = {
    attach: function (context, settings) {
      once('layerone-sticky-header', '#header', context).forEach(function (header) {
        var sentinel = header.querySelector('.header-sticky-sentinel');
        var row = header.querySelector('.header-row');
        if (!sentinel || typeof IntersectionObserver === 'undefined') {
          return;
        }

        // Only re-measured while unstuck, so a resize that happens while
        // stuck (header.offsetHeight would just be ~0 then) can't
        // corrupt this with the wrong value.
        var naturalHeight = header.offsetHeight;
        window.addEventListener('resize', function () {
          if (!header.classList.contains('is-stuck')) {
            naturalHeight = header.offsetHeight;
          }
          // Stuck, then resized down to a phone width, where <header> no
          // longer collapses: drop the padding that stood in for it.
          else if (header.offsetHeight > 0 && header.nextElementSibling) {
            header.nextElementSibling.style.paddingTop = '';
          }
        });

        var observer = new IntersectionObserver(function (entries) {
          var isStuck = !entries[0].isIntersecting;
          var target = header.nextElementSibling;

          header.classList.toggle('is-stuck', isStuck);

          // Site header rebuild follow-up (docs/site_header_rebuild_
          // plan.md §5/§7): this whole padding hand-off only exists to
          // compensate for <header>'s own box collapsing once stuck -
          // real in Banner mode, where <header> actually had a real,
          // configured height/background a moment ago. In Floating
          // mode <header> never had a box at all, position: absolute/
          // fixed with zero height from the very first pixel (_header.
          // scss) - there's nothing to hand back, so there's nothing to
          // compensate for. Without this check, target still picked up
          // a real chunk of padding the instant scrolling started
          // (row.offsetHeight - a real, non-zero size regardless of
          // position: fixed - not 0), reported as an unwanted gap
          // appearing out of nowhere on first scroll.
          if (header.classList.contains('site-header--floating')) {
            return;
          }

          if (!target) {
            return;
          }

          // Only when <header> really did collapse. The collapse is
          // desktop-only (_header.scss, md and up): on a phone <header>
          // keeps its full height once stuck, and padding target as well
          // dropped the page by the header's whole height.
          if (isStuck && header.offsetHeight > 0) {
            target.style.transition = '';
            target.style.paddingTop = '';
            return;
          }

          if (isStuck) {
            var stuckHeight = row.offsetHeight;
            // Land target's padding-top on the exact height <header>
            // just gave up, with no transition, before handing back to
            // the CSS-driven one (_header.scss) that eases it down to
            // the shrunk row's height - going straight to stuckHeight
            // would just ease UP from whatever padding-top already was
            // (0), not down from the full height the eye needs to see
            // leaving.
            target.style.transition = 'none';
            target.style.paddingTop = naturalHeight + 'px';
            // Forces layout now, so the line above actually lands before
            // transitions are re-enabled just below - without this the
            // browser can coalesce both style changes into one and skip
            // the transition entirely.
            void target.offsetHeight;
            target.style.transition = '';
            target.style.paddingTop = stuckHeight + 'px';
          }
          else {
            target.style.transition = '';
            target.style.paddingTop = '';
          }
        }, { threshold: 0 });

        observer.observe(sentinel);
      });
    }
  };

  // Site header rebuild follow-up (docs/site_header_rebuild_plan.md §5):
  // Floating mode's <header> deliberately has no box of its own at all
  // (_header.scss - position: absolute/fixed, no height), so the page's
  // first real content shows through behind the logo/nav row - correct,
  // intentional, kept as the general design (a hero banner is meant to
  // have the nav float over it). But on two specific templates the
  // element sitting there isn't a hero image, it's plain page content
  // that genuinely gets cut into: the user page's own #banner (just a
  // breadcrumb + "Account details" heading, page--user.html.twig) and a
  // standard content page's first "Header" paragraph (.background-
  // container, paragraph--header--default.html.twig) - #banner there
  // renders with no block placed in it at all, so it's the Header
  // paragraph, further down inside #main-wrapper, that's actually first.
  // Named directly rather than guessed at a general "is this empty"
  // heuristic - a page that legitimately wants the overlay (the
  // homepage's own hero banner, in the same #banner element) must keep
  // it, and there's no reliable way to tell "empty banner" from "hero
  // banner" from content alone. #banner.search-banner only exists on
  // page--user.html.twig, so it's unambiguous; #main-wrapper .background-
  // container falls back to the first Header paragraph only when no
  // user-page banner is present at all.
  Drupal.behaviors.layeroneFloatingNavPadding = {
    attach: function (context, settings) {
      once('layerone-floating-nav-padding', '#header.site-header--floating', context).forEach(function (header) {
        var row = header.querySelector('.header-row');
        var target = document.querySelector('#banner.search-banner');

        if (!target) {
          // .background-container is the outer element carrying the
          // *background image* (paragraph--header--default.html.twig) -
          // padding it directly pushes .image-overlay (the inner div
          // carrying the *gradient*, always present as a class even
          // when no gradient colour is configured) down with it, so the
          // gradient no longer reaches the top strip of image the
          // padding now exposes. Padding .image-overlay itself instead
          // grows *its* own box (and .background-container along with
          // it, sized to fit) - the gradient covers exactly as much
          // image as there now is. Other paragraph types reusing
          // .background-container (e.g. paragraph--view--default.html.
          // twig) have no .image-overlay at all - padding the outer
          // element directly is correct there, nothing to mismatch.
          var backgroundContainer = document.querySelector('#main-wrapper .background-container');
          target = backgroundContainer && (backgroundContainer.querySelector('.image-overlay') || backgroundContainer);
        }

        if (!row || !target) {
          return;
        }

        // getBoundingClientRect() rather than offsetHeight - row is
        // position: fixed (at md+; in-flow below it), and offsetHeight/
        // offsetParent have known cross-browser quirks specifically for
        // fixed-position elements. Guarded on a real (>0) height before
        // ever writing it - row's actual rendered size can still be
        // settling (web fonts, the logo's own background image) the
        // instant behaviors first attach, and writing a 0/invalid
        // measurement then is exactly what left an empty, effectively
        // no-op style="" behind rather than the real value arriving a
        // moment later.
        function applyPadding() {
          var height = row.getBoundingClientRect().height;
          if (height > 0) {
            target.style.paddingTop = height + 'px';
          }
        }

        applyPadding();
        // One more pass once the browser's actually finished a layout/
        // paint pass, not just whenever behaviors happen to attach -
        // catches the row settling into its real size a frame or two
        // later than the first read above.
        window.requestAnimationFrame(applyPadding);
        window.addEventListener('load', applyPadding);
        window.addEventListener('resize', applyPadding);
      });
    }
  };

})(jQuery, Drupal);
